//Estatus
export const ESTATUS_ACTIVO = "A";
export const ESTATUS_INACTIVO = "I";
export const ESTATUS_BLOQUEADO = "B";
export const ESTATUS_ACTIVO_LABEL = "Activa";
export const ESTATUS_BLOQUEADO_LABEL = "Bloqueada";
export const ESTATUS_INACTIVO_LABEL = "Inactiva";

//Ambiente
const AMBIENTE_PRUEBAS = "T";
const AMBIENTE_PRUEBAS_LABEL = "Prueba";
const AMBIENTE_SIMULACION = "S";
const AMBIENTE_SIMULACION_LABEL = "Simulación";
const AMBIENTE_CERTIFICACION = "C";
const AMBIENTE_CERTIFICACION_LABEL = "Certificación";
const AMBIENTE_PRODUCCION = "P";
const AMBIENTE_PRODUCCION_LABEL = "Producción";

export class Compania {
  static Citrus = 10;
  //EstadoCertificacion
  static ESTADO_CERTIFICACION_PENDIENTE = "P";
  static ESTADO_CERTIFICACION_PENDIENTE_LABEL = "Pendiente";
  static ESTADO_CERTIFICACION_VALIDANDO = "V";
  static ESTADO_CERTIFICACION_VALIDANDO_LABEL = "Validando Credenciales";
  static ESTADO_CERTIFICACION_EN_PROCESO = "X";
  static ESTADO_CERTIFICACION_EN_PROCESO_LABEL = "Certificación en proceso";
  static ESTADO_CERTIFICACION_EN_ESPERA_DGII = "E";
  static ESTADO_CERTIFICACION_EN_ESPERA_DGII_LABEL = "En espera por DGII";
  static ESTADO_CERTIFICACION_ERROR_DECLARACION_JURADA = "J";
  static ESTADO_CERTIFICACION_ERROR_DECLARACION_JURADA_LABEL = "Error: Declaración Jurada";
  static ESTADO_CERTIFICACION_COMPLETADO = "C";
  static ESTADO_CERTIFICACION_COMPLETADO_LABEL = "Completado exitosamente";

  static get AMBIENTE_DESC() {
    switch (this.Estatus) {
      case AMBIENTE_PRUEBAS:
        return AMBIENTE_PRUEBAS_LABEL;
      case AMBIENTE_SIMULACION:
        return AMBIENTE_SIMULACION_LABEL;
      case AMBIENTE_CERTIFICACION:
        return AMBIENTE_CERTIFICACION_LABEL;
      case AMBIENTE_PRODUCCION:
        return AMBIENTE_PRODUCCION_LABEL;
    }
  }

  static get AMBIENTE_LIST() {
    return [
      {
        value: AMBIENTE_PRUEBAS,
        label: AMBIENTE_PRUEBAS_LABEL,
      },
      {
        value: AMBIENTE_SIMULACION,
        label: AMBIENTE_SIMULACION_LABEL,
      },
      {
        value: AMBIENTE_CERTIFICACION,
        label: AMBIENTE_CERTIFICACION_LABEL,
      },
      {
        value: AMBIENTE_PRODUCCION,
        label: AMBIENTE_PRODUCCION_LABEL,
      },
    ];
  }

  static get ESTATUS_DESC() {
    switch (this.Estatus) {
      case ESTATUS_ACTIVO:
        return ESTATUS_ACTIVO_LABEL;
      case ESTATUS_INACTIVO:
        return ESTATUS_INACTIVO_LABEL;
      case ESTATUS_BLOQUEADO:
        return ESTATUS_BLOQUEADO_LABEL;
    }
  }
  static get ESTATUS_LIST() {
    return [
      {
        value: ESTATUS_ACTIVO,
        label: ESTATUS_ACTIVO_LABEL,
      },
      {
        value: ESTATUS_INACTIVO,
        label: ESTATUS_INACTIVO_LABEL,
      },
      {
        value: ESTATUS_BLOQUEADO,
        label: ESTATUS_BLOQUEADO_LABEL,
      },
    ];
  }

  static get ESTADO_CERTIFICACION_LIST() {
    return [
      { value: Compania.ESTADO_CERTIFICACION_PENDIENTE, label: Compania.ESTADO_CERTIFICACION_PENDIENTE_LABEL },
      { value: Compania.ESTADO_CERTIFICACION_VALIDANDO, label: Compania.ESTADO_CERTIFICACION_VALIDANDO_LABEL },
      { value: Compania.ESTADO_CERTIFICACION_EN_PROCESO, label: Compania.ESTADO_CERTIFICACION_EN_PROCESO_LABEL },
      { value: Compania.ESTADO_CERTIFICACION_EN_ESPERA_DGII, label: Compania.ESTADO_CERTIFICACION_EN_ESPERA_DGII_LABEL },
      { value: Compania.ESTADO_CERTIFICACION_ERROR_DECLARACION_JURADA, label: Compania.ESTADO_CERTIFICACION_ERROR_DECLARACION_JURADA_LABEL },
      { value: Compania.ESTADO_CERTIFICACION_COMPLETADO, label: Compania.ESTADO_CERTIFICACION_COMPLETADO_LABEL },
    ];
  }

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  }
  static get DEFAULT_AMBIENTE_VALUE() {
    return AMBIENTE_PRUEBAS;
  }

  static get PROPIEDADES_EXPORTAR () {
    return [
      { value: "Id", label: "Id" },
      { value: "Codigo", label: "Código" },
      { value: "RNC", label: "RNC" },
      { value: "Nombre", label: "Nombre" },
      { value: "RazonSocial", label: "Razón Social" },
      { value: "DireccionLinea1", label: "Dirección" },
      { value: "Email", label: "Email" },
      { value: "PaginaWeb", label: "Página Web" },
      { value: "TelefonoPrincipal", label: "Teléfono Principal" },
      { value: "TelefonoSecundario", label: "Teléfono Secundario" },
      { value: "Extension1", label: "Extensión 1" },
      { value: "Extension2", label: "Extensión 2" },
      { value: "Fax", label: "Fax" },
      { value: "_EstatusDesc", label: "Estatus" },
      { value: "_AmbienteDesc", label: "Ambiente" },
      { value: "EsPrincipal", label: "Es Principal" },
      { value: "EsTenant", label: "Es Tenant" },
      { value: "CompaniaTenantId", label: "Compañía Tenant" },
      { value: "ClienteId", label: "ID Cliente" },
      { value: "CantidadTransacciones", label: "Cantidad de Transacciones" },
      { value: "CantidadPT", label: "Cantidad PT" },
      { value: "FechaExpiracionCertificado", label: "Fecha Expiración Certificado" },
      { value: "IncluirITBISDetalles", label: "Incluir ITBIS en Detalles" },
      { value: "MostrarValorPagar", label: "Mostrar Valor a Pagar" },
      { value: "IncluirSubTotalesInformativos", label: "Incluir Sub-Totales Informativos" },
      { value: "UsaSerieFiscal", label: "Usa Serie Fiscal automática" },
      { value: "MostrarRetencionesEnTotales", label: "Mostrar Retenciones en Totales" },
      { value: "TipoIntegracion", label: "Tipo Integración" },
      { value: "EsModoContigenciaLigera", label: "Modo Contingencia Ligera" },
      { value: "NoPermitirDuplicadoFacturaInterna", label: "No Permitir Duplicado Factura Interna" },
      { value: "UtilizarDescripcionNombreItem", label: "Utilizar Descripción como Nombre Item" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" }
    ]
  }
}
